<app-toggle-pill-group
  class="language-toggle"
  idPrefix="language"
  [options]="options"
  [values]="active"
  (valuesChange)="onValuesChange($event)"
></app-toggle-pill-group>
